export const BRAND = {
  name: "The Roots Club",
  logo: "/brand/logo.png",
  lindsay: "/brand/lindsay.jpg",
  leaf: "/brand/leaf.png",
  photos: [],
  signupOpen: false,
};
